<template>
    <div class="margin-20 d-flex flex-column">
    <div class="d-flex flex-row pointer" @click="showDish()">
      <div class="f17-l19-m flex-grow-1 two-lines-on-carousel two-lines-on-search text-truncate-on-carousel" style="height:40px;max-height:40px;word-break:break-word;white-space: break-spaces;">{{dish.sections.title.text}}</div>
    </div>
    <div v-if="dish.sections.description" class="f14-l17-l text-break two-lines-on-carousel three-lines-on-desktop three-lines-on-tablet  deal-preview">
      <ReadMore :text="dish.sections.description.text_html" :moreText="dish.sections.description.more_text.text" :disableDesktopMode="true" :lines="2" :pushDown="this.$isDesktop()" />
    </div>
    <!-- <div class="text-left " style="min-width:30%;">
      <div class="f14-l18 red one-line-on-desktop one-line-on-tablet" style="margin-right: 5px;">{{dish.price_options.about_price.display.text}}</div>
    </div> -->
    <div :class="`f14-l17 dish-list-frame mmargin-top-15 ${!previewMode ? `dpush-up-list` : ``} `" >
      <div v-for="(portion, idx) in dish.price_options.portions" :key="idx">
        <div class="d-flex flex-row mmargin-bottom-10" dir="rtl">
          <!-- <div>{{portion.portion.id==selectedPortion.id  }}</div> -->
          <div class="mr-auto align-items-start" style="display: inherit;">
            <input v-if="!previewMode" class="red-radio" type="radio" style="margin-left: 5px; margin-top:1px;"  :checked="portion.portion.id==selectedPortion.id" :id="`portion_`+dish.radio_id+'_'+idx" @change="selectPortion(portion.portion)" />
            <label class="c17" :for="`portion_`+dish.radio_id+'_'+idx">{{previewMode ? "* " : ""}}{{portion.portion.menu_name}} </label>
          </div>
          <div class="ml-auto text-left flex-grow-1" :style="priceWidth(portion.portion.discounted)">
              <!-- <div class="flex-grow-1"></div> -->
              <PriceComponent v-if="portion.portion.discounted" class="stroke margin-space-after" :value="portion.portion.nominal_price" />
              <PriceComponent :value="portion.portion.unit_price" />
              <bdi v-if="portion.portion.discounted" class="f14-l18 red " style="margin-right: 5px; direction: rtl;">{{dish.price_options.about_price.display.text}}</bdi>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center line-height-05 save-space-25 margin-top-10 margin-bottom-10">
      <span class="f13-l16-l" v-for="(p,pkey) in dish.sections.dishes_filter_tags" :key="pkey">{{p.text}}<span v-if="pkey<Object.keys(dish.sections.dishes_filter_tags).length-1" class="red strong"> | </span> </span>
    </div>
  </div>
</template>
<script>
  import ReadMore from "@/components/generic/ReadMore.vue";
  import PriceComponent from "@/components/generic/PriceComponent.vue";
  export default {
    data() {
      return {
        amount: 0,
        selectedPortion: {},
      }
    },
    components: {
      // DishPreferenceComponent,
      ReadMore,
      PriceComponent,
    },
    props: {
      dish: Object,
      previewMode: Boolean

    },
    mounted() {
      let data = this.dish;
      this.selectedPortion = data?.price_options?.portions[0]?.portion || {};
      this.amount = this.selectedPortion.min || 1;
      this.$emit('portion-selected', this.selectedPortion);
    },
    computed: {
      // price() {
      //   return parseFloat(this.amount * (this.getSelectedPortion()?.unit_price || 0)).toFixed(2);
      // },
      // addToCartText() {
      //   return this.getSelectedPortion()?.action_btn?.label;
      // }
    },
    methods: {
      showDish() {
        this.$router.push(this.dish.url);
        // this.$store.dispatch('fetchDish', this.dish.url);
        // let offcanvas = document.getElementById("offcanvasExample");
        // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
        // bsOffcanvas.show();
      },
      selectPortion(portion) {
        this.selectedPortion = portion;
        this.$emit('portion-selected', this.selectedPortion);
        // this.amountPlus(0); //to fix min/max based on portion
        // this.changeAmountToMin();
      },
      getSelectedPortion() {
        if (this.selectedPortion?.unit_price) return this.selectedPortion;
        if (this.dish?.price_options) return this.dish.price_options.portions[0].portion;
        return null;
      },
      priceWidth(discounted) {
        const width = discounted ? '45%' : '15%';
        return `width: ${width} !important;`; 
      },
    }
  }
</script>
<style scoped>
  @media (min-width: 768px) {
    .dish-list-frame {
      min-height: 9.3em;
    }
    /* .dpush-up-list {
      margin-top: -10px;
    } */
  }

@media (min-width: 1200px) {
    .dish-list-frame {
      min-height: 7.3em;
    }
    .dpush-up-list {
      margin-top: -10px;
    }
  }
</style>
